const config = {
  section: {
    maxWidth: 300,
    minWidth: 200,
  },
  shelf: {
    30463744: {
      leftId: 'BOAXEL_30463744_adj_metal_shelf_thin_20_30_2',
      rightId: 'BOAXEL_30463744_adj_metal_shelf_thick_20_30_2',
    },
    30575586: {
      leftId: 'BOAXEL_30575586_adj_metal_shelf_thin_20_30_2',
      rightId: 'BOAXEL_30575586_adj_metal_shelf_thick_20_30_2',
    },
  },
  clothesrail: {
    70463742: {
      leftId: 'BOAXEL_70463742_adj_clothes_rail_thin_20_30_2',
      rightId: 'BOAXEL_70463742_adj_clothes_rail_thick_20_30_2',
    },
    50575585: {
      leftId: 'BOAXEL_50575585_adj_clothes_rail_thin_20_30_2',
      rightId: 'BOAXEL_50575585_adj_clothes_rail_thick_20_30_2',
    },
  },
  legs: {
    topId: 'pair_of_legs_thick_60_10_120',
    bottomId: 'pair_of_legs_thin_60_10_120',
    maxHeight: 840,
    minHeight: 665,
  },
};

export { config };
